//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { AppContext } from './models/AppContext';
import type { MaintenanceConfigurationResponse } from './models/MaintenanceConfigurationResponse';
import { Utilities } from './Utilities';

export class AppContextsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        get: (): string => {
            let clientRequestUrl = '/api/v1/app-contexts';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getMaintenancePageToggle: (): string => {
            let clientRequestUrl = '/api/v1/app-contexts/maintenance-configuration';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get application context
     * @return OK
     */
    async get(): Promise<AppContext> {
        const clientRequestUrl = this.baseUrl + this.routes.get();

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<AppContext>(_response, false, []);
    }

    /**
     * Get maintenance page toggle
     * @return OK
     */
    async getMaintenancePageToggle(): Promise<MaintenanceConfigurationResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getMaintenancePageToggle();

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<MaintenanceConfigurationResponse>(_response, false, ['maintenanceEndDate']);
    }
}
